module.exports = __webpack_public_path__ + "img/icon-ticket.553df312.svg";